import { AccountInfo } from 'app/api/@generated/backend';

import { CustomerService } from 'app/pages/order/services/customer-service';
import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';
import { selectSelectedAccountOrThrow } from 'app/pages/order/redux/order-selector';

export const fetchAccountInfoActionCreator = createAppAsyncThunk<AccountInfo>(
    'order/fetchAccountInfo',
    async (_, { getState }) => {
        const rootState = getState();
        const selectedAccount = selectSelectedAccountOrThrow(rootState);

        const { customerId, partnerId } = selectedAccount;

        return CustomerService.getAccountInfo(customerId, partnerId);
    },
    {
        getPendingMeta: () => ({ requestType: RequestType.GET_ACCOUNT_INFORMATION }),
    },
);
